import {Directive, HostBinding} from '@angular/core';

@Directive({
  selector: '[vdwRadioToggleButton]'
})
export class RadioToggleButtonDirective {
  @HostBinding('class.radio-toggle-buttons') public radioToggleButtons = true;
}
